<template lang="pug">
  .b2b-page-centres
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("centres.delete_centre")', placement='bottom')
                ods-button(
                  v-if='showDeleteOption()'
                  type='primary',
                  icon='ods-icon-delete',
                  size='small',
                  circle,
                  @click.native='handleDeleteCentre')
                  | {{ $t('centres.delete_centre') }}
      ods-form(
        ref='centreDetailForm',
        :model='centreDetailForm',
        :rules='centreDetailFormRules'
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              prop='description',
              :label='$t("centres.entity_table.nameCentre")')
              ods-input(
                v-model='centreDetailForm.description',
                :disabled='showEditOption(true)')
            ods-form-item(
              prop='gln',
              :label='$t("centres.entity_table.gln")')
              ods-input(
                v-model='centreDetailForm.gln',
                :disabled='showEditOption(true)')
            ods-form-item(
              prop='town',
              :label='$t("centres.entity_table.town")')
              ods-input(
                v-model='centreDetailForm.town',
                :disabled='showEditOption(true)')
            ods-form-item(
              prop='province',
              :label='$t("centres.entity_table.province")')
              ods-input(
                v-model='centreDetailForm.province',
                :disabled='showEditOption(true)')
            ods-form-item(
              :label='$t("centres.entity_table.country")',
              prop='countryId')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='centreDetailForm.countryId',
                :disabled='showEditOption(true)'
                filterable,
                :placeholder='$t("centres.entity_table.country")')
                ods-option(
                  v-for='option in countries',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='centreCode',
              :label='$t("centres.entity_table.code")')
              ods-input(
                v-model='centreDetailForm.centreCode',
                :disabled='showEditOption(true)')
            ods-form-item.hidden(
              label=' ',
              prop='buzon')
              ods-input(
                v-model='centreDetailForm.buzon'
                :disabled='true')
            ods-form-item(
              prop='address',
              :label='$t("centres.entity_table.address")')
              ods-input(
                v-model='centreDetailForm.address',
                :disabled='showEditOption(true)')
            ods-form-item(
              prop='postcode',
              :label='$t("centres.entity_table.postcode")')
              ods-input(
                v-model='centreDetailForm.postcode',
                :disabled='showEditOption(true)')
            ods-form-item(
              prop='centreType',
              :label='$t("centres.entity_table.centreType")')
              ods-select(
                @change='changeTypeCentre'
                :no-match-text='$t("msg_generics.no_match")',
                :disabled='showEditOption(true)'
                v-model='centreDetailForm.centreType',
                filterable,
                :placeholder='$t("centres.entity_table.centreType")')
                ods-option(
                  v-for='option in comboTypeCentre',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
    ods-row.form-actions()
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='showEditOption(false)'
            type='primary',
            size='large'
            @click='saveCentre("centreDetailForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnCancel")', placement='bottom')
          ods-button(
            v-if='showEditOption(false)'
            ref='buttonCancel',
            type='neutral',
            size='large'
            @click='cancelCentreDetailEditForm')
            | {{ $t('buttons.btnCancel') }}

      ods-module.collapse
        ods-accordion(@change='')
          ods-accordion-item(
            v-if='canAdminIndra || ((centreDetailForm.edition ||(!centreDetailForm.edition && datacentremedia.length > 0)) && this.withProject)',
            name='1')
            template(slot='title')
              span {{ $t('party_detail.contact_data') }}
              span.info(v-show='!datacentremedia.length') {{ $t('centres.no_contact_data') }}

            //- Tabla de centremedia
            ods-table(
              v-if='datacentremedia.length > 0 ',
              :data='datacentremedia',
              :default-sort="{ prop: 'id', order: 'descending' }",
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterCentreMedia',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='projectName',
                :label='$t("party_detail.party_media_table.project")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='mediaTypeId',
                :label='$t("party_detail.party_media_table.media_type")',
                :show-overflow-tooltip='true',
                :formatter='formatterMediaType',
                sortable='')
              ods-table-column(
                prop='mediaValue',
                :label='$t("party_detail.party_media_table.contact_data")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='typeText',
                :label='$t("party_detail.party_media_table.party_type")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                    ods-button(
                      type='neutral',
                      @click='removeCentreMedia')
                      ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
              ods-button.button-collapse(
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='isShowDialogCentreMedia = true')
                | {{ $t('party_detail.buttons.add_contact_data') }}

          //- Rol de centro
          ods-accordion-item(name="2")
            template(slot="title")
              span {{ $t('centres.centre_roles') }}
              span.info(v-show="!centreroles.length") {{ $t('centres.no_centre_role') }}

            //- Tabla CentreRoleType
            ods-table(
              v-if="centreroles.length > 0",
              :data="centreroles",
              :default-sort="{ prop: 'centreRoletypecode', order: 'ascending' }",
              style="width: 100%",
              @cell-mouse-enter="handleCellMouseEnterCentreRole",
              highlight-current-row,
              size="mini",
              fit
            )
              ods-table-column(
                prop="centreRoleTypeCode",
                :label="$t('centres.centre_roles_table.name')",
                :show-overflow-tooltip="true",
                :formatter="formatterCentreRole",
                sortable=""
              )
              ods-table-column(
                v-if='canAdminIndra || (canChangeCentreRoles && centreDetailForm.edition)',
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                    ods-button(
                      type='neutral',
                      @click='removeCentreRole')
                      ods-icon(name='close', size='16')
            ods-tooltip(
              :content="$t('centres.buttons.add_centre_role.content')",
              placement="bottom"
            )
              ods-button.button-collapse(
                v-if='canAdminIndra || (canChangeCentreRoles && centreDetailForm.edition)',
                icon="ods-icon-plus",
                size="small",
                circle,
                @click.native="isShowDialogCentreRole = true"
              )
                | {{ $t('centres.buttons.add_centre_role.label') }}

    //- Dialogo Datos de contacto centremedia
    ods-dialog(
      ref='dialogCentreMedia',
      :title='$t("party_detail.dialog_add_contact_data.title")',
      :visible.sync='isShowDialogCentreMedia',
      @close='handleCloseDialogCentreMedia',
      width='30%')
      ods-form(
        ref='formDialogCentreMedia',
        :model='dialogCentreMediaForm',
        :rules='rulesCentreMediaForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.media_type.label")',
            prop='mediaTypeId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogCentreMediaForm.mediaTypeId',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.media_type.placeholder")')
              ods-option(
                v-for='option in optionsFilterMediaType',
                :key='option.id',
                :label='$t("mediaType." + option.media)',
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.party_type.label")',
            prop='rol')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogCentreMediaForm.rol',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.party_type.placeholder")')
              ods-option(
              v-for='option in comboTypeList',
              :key='option.code',
              :label='$t(option.description)',
              :value='option.code')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.contact_data.label")',
            prop='value')
            ods-input(
              v-model.trim='dialogCentreMediaForm.value')
      span.dialog-footer(slot='footer')
        ods-tooltip(:content='$t("buttons.btnAdd")', placement='bottom')
          ods-button(
            type='primary',
            @click.native='addCentreMedia("formDialogCentreMedia")')
            | {{ $t('buttons.btnAdd') }}
    //- Dialogo añadir Rol al centro
    ods-dialog(
      ref="dialogCentreRole",
      :title="$t('centres.dialog_add_centre_role.title')",
      :visible.sync="isShowDialogCentreRole",
      @close="handleCloseDialogCentreRole",
      width="30%"
    )
      ods-form(
        ref="formDialogCentreRole",
        :model="dialogCentreRoleForm",
        :rules="rulesCentreRoleForm"
      )
        ods-form-item(
          :label="$t('centres.dialog_add_centre_role.role_type.label')",
          prop="roleTypeId"
        )
          ods-select(
            :no-match-text="$t('msg_generics.no_match')",
            v-model="dialogCentreRoleForm.roleTypeId",
            filterable,
            :placeholder="$t('centres.dialog_add_centre_role.role_type.placeholder')"
          )
            ods-option(
              v-for="option in optionsFilterCentreRoleType",
              :key="option.id",
              :label="$t('centre_role_type.' + option.code)",
              :value="option.id"
            )
              span.dialog-footer(slot="footer")
      ods-tooltip(:content="$t('buttons.btnAdd')", placement="bottom")
        ods-button(
          type="primary",
          @click.native="addCentreRole('formDialogCentreRole')"
        )
          | {{ $t('buttons.btnAdd') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-centres',
  mixins: [Utils],
  data () {
    const self = this
    const validateContact = (rule, value, callback) => {
      if (self.dialogCentreMediaForm.mediaTypeId !== 1) {
        if (this.checkCorrectPhoneNumber(value)) {
          callback()
        } else {
          callback(
            new Error(this.$t('profile.contact.rules_form.phone_format'))
          )
        }
      } else {
        if (this.checkCorrectEmail(value)) {
          callback()
        } else {
          callback(new Error(this.$t('profile.contact.rules_form.email_format')))
        }
      }
    }
    return {
      centreDetailForm: {
        description: null,
        gln: null,
        town: null,
        province: null,
        centreCode: null,
        buzon: null,
        address: null,
        postcode: null,
        countryId: null,
        centreType: null
      },
      currentRow: {},
      isBuyer: null,
      withProject: true,

      // Validaciones
      centreDetailFormRules: {
        description: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          },
          {
            max: 100,
            message: this.$t('msg_generics.max_num_character', { max: 100 }),
            trigger: 'change'
          }
        ],
        gln: [
          {
            max: 15,
            message: this.$t('msg_generics.max_num_character', { max: 15 }),
            trigger: 'change'
          }
        ],
        town: [
          {
            required: true,
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        province: [
          {
            required: true,
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        centreCode: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          },
          {
            max: 30,
            message: this.$t('msg_generics.max_num_character', { max: 30 }),
            trigger: 'change'
          }
        ],
        buzon: [
          {
            max: 13,
            message: this.$t('msg_generics.max_num_character', { max: 13 }),
            trigger: 'change'
          }
        ],
        address: [
          {
            required: true,
            max: 100,
            message: this.$t('msg_generics.max_num_character', { max: 100 }),
            trigger: 'change'
          }
        ],
        postcode: [
          {
            required: true,
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        centreType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }

        ],
        countryId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }

        ]
      },
      // Combo tipo centro
      comboTypeCentre: [{
        value: 'BUYER',
        label: this.$t('centres.filters.centre_type.buyer')
      }, {
        value: 'SELLER',
        label: this.$t('centres.filters.centre_type.seller')
      }, {
        value: 'BOTH',
        label: this.$t('centres.filters.centre_type.both')
      }
      ],

      // DATOS DE CONTACTO
      datacentremedia: [],
      currentRowCentreMedia: {},

      isShowDialogCentreMedia: false,

      dialogCentreMediaForm: {
        mediaTypeId: null,
        rol: null,
        value: null
      },

      rulesCentreMediaForm: {
        mediaTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ],
        rol: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ],
        value: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          },
          {
            validator: validateContact,
            trigger: 'change'
          }
        ]
      },

      comboTypeList: [],

      // ROL DE CENTRO
      centreroles: [],
      currentRowCentreRole: {},
      // Tipos de roles de centro por comprador/vendedor
      optionsFilterCentreRoleType: [],

      isShowDialogCentreRole: false,

      dialogCentreRoleForm: {
        roleTypeId: null
      },

      rulesCentreRoleForm: {
        roleTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'optionsFilterMediaType',
      'countries',
      'canAdminIndra',
      'canChangeCentreRoles',
      'activeUser',
      'canEditOrDeleteCentreWithPermanentEstablishment'
    ])
  },

  methods: {
    ...mapActions([
      'getCentreById',
      'modifyCentre',
      'getCentreMedia',
      'getOptionsFilterMediaType',
      'getOptionsFilterCentreRoleType',
      'deleteCentreMedia',
      'insertCentreMedia',
      'deleteCentreProjectParties',
      'getCentreRoleTypeCode',
      'deleteCentreRoleTypeCode',
      'insertCentreRoleTypeCode',
      'B2bCreateConfig',
      'setUserNameCentre'
    ]),

    //  Reseteo al cerrar dialogo
    handleCloseDialogCentreMedia () {
      this.$refs.formDialogCentreMedia.resetFields()
    },

    handleCloseDialogCentreRole () {
      this.$refs.formDialogCentreRole.resetFields()
    },

    handleCellMouseEnterCentreMedia (row, column, cell, event) {
      this.currentRowCentreMedia = row
    },

    handleCellMouseEnterCentreRole (row, column, cell, event) {
      this.currentRowCentreRole = row
    },

    // Lógica para mostrar los botones de editar y cancelar, así como si los campos son editables
    showEditOption (param) {
      let result
      // Si tiene el flag de establecimiento permanente solo será editable si tiene el permiso
      if (this.centreDetailForm.permanentEstablishment) {
        result = this.centreDetailForm.edition && this.canEditOrDeleteCentreWithPermanentEstablishment
      } else {
        result = this.canAdminIndra || this.centreDetailForm.edition
      }
      return param ? !result : result
    },

    showDeleteOption () {
      // Si tiene el flag de establecimiento permanente solo será borrable si tiene el permiso
      if (this.centreDetailForm.permanentEstablishment) {
        return this.centreDetailForm.erasable && this.canEditOrDeleteCentreWithPermanentEstablishment
      }
      return this.centreDetailForm.erasable
    },

    async changeTypeCentre () {
      this.comboTypeCentre = [
        { value: 'BUYER', label: this.$t('centres.filters.centre_type.buyer') },
        { value: 'SELLER', label: this.$t('centres.filters.centre_type.seller') },
        { value: 'BOTH', label: this.$t('centres.filters.centre_type.both') }
      ]
      this.comboTypeList = []
      if (this.centreDetailForm.centreType === 'BUYER') {
        this.comboTypeList.push({ code: 'buyer', description: 'party_type.buyer' })
      } else if (this.centreDetailForm.centreType === 'SELLER') {
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
      } else if (this.centreDetailForm.centreType === 'BOTH') {
        this.comboTypeList.push({ code: 'buyer', description: 'party_type.buyer' })
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
        this.comboTypeList.push({ code: 'both', description: 'party_type.both' })
      }
    },

    // Valida que no se inserte mas de 5 correo electronicos para el mismo proyecto. TRUE OK FALSE KO
    validateEmail (entityToAdd) {
      const datacentremediaaux = []
      // Exclusivo para correo electronico
      if (entityToAdd.mediaTypeId === 1) {
        if (this.datacentremedia !== null && this.datacentremedia.length > 0) {
          for (const entity of this.datacentremedia) {
            if (entity.mediaTypeId === '1' && entity.projectId === entityToAdd.projectId) {
              datacentremediaaux.push(entity)
            }
          }

          if (datacentremediaaux.length === 5) {
            return false
          }
        }
      }

      return true
    },

    // Valida si el contacto ya a sido insertado previamete. TRUE OK FALSE KO
    validateDataContactRepeat (entityToAdd) {
      // Verificamos que la lista no esta vacia
      if (this.datacentremedia !== null && this.datacentremedia.length > 0) {
        // Verificamos que no se añadido previamnete
        for (const entity of this.datacentremedia) {
          if (entity.projectId === entityToAdd.projectId &&
              parseInt(entity.mediaTypeId) === entityToAdd.mediaTypeId &&
              entity.mediaValue === entityToAdd.value) {
            return false
          }
        }
      }
      return true
    },

    /* Formatea el tipo de contacto */
    formatterMediaType (row, column) {
      const mediaType = this.optionsFilterMediaType.find(function (elem) {
        return Number(row[column.property]) === elem.id
      })
      if (mediaType) return this.$t('mediaType.' + mediaType.media)
      else return '-'
    },

    /* Formatea el tipo de rol */
    formatterCentreRole (row, column) {
      return this.$t('centre_role_type.' + row[column.property])
    },

    /* Crea el combo de tipo de empresa al aniadir contactos */
    loadComboCentreMediaTypeParty () {
      this.comboTypeList = []

      if (this.centreDetailForm.buyer) {
        this.comboTypeList.push({
          code: 'buyer',
          description: 'party_type.buyer'
        })
      }
      if (this.centreDetailForm.seller) {
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
      }
      if (this.centreDetailForm.buyer && this.centreDetailForm.seller) {
        this.comboTypeList.push({ code: 'buyer', description: 'party_type.buyer' })
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
        this.comboTypeList.push({ code: 'both', description: 'party_type.both' })
      }
    },

    getTypeCentre () {
      if (this.centreDetailForm.buyer && this.centreDetailForm.seller) {
        this.centreDetailForm.centreType = 'BOTH'
        this.isBuyer = null
      } else if (this.centreDetailForm.buyer) {
        this.centreDetailForm.centreType = 'BUYER'
        this.isBuyer = true
      } else if (this.centreDetailForm.seller) {
        this.centreDetailForm.centreType = 'SELLER'
        this.isBuyer = false
      }
    },

    // Detalle Centros
    async getCentresOnDatabase () {
      try {
        const centreId = this.$route.params.centreId
        let projectId

        // Verificar si this.$route.params.projectId existe
        if (this.$route.params.projectId) {
          projectId = this.$route.params.projectId
          // Si solo tiene el usuario un servicio
        } else if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
          projectId = this.activeUser.data.projects[0].id
        } else {
          projectId = null
        }

        const data = { centreId: centreId, projectId: projectId }
        this.centreDetailForm = await this.getCentreById(data)
        // Tipo de centro
        this.getTypeCentre()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    changeBreadcrumbPath (centreId) {
      this.$route.meta.breadcrumb = centreId
    },

    // Guarda los cambios del centro
    saveCentre (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('saveCentre: ', this.centreDetailForm)
          const load = this.$loading({
            lock: true,
            text: this.$t('centres.save_changes_load')
          })
          try {
            const response = await this.modifyCentre({
              centreId: this.$route.params.centreId,
              params: {
                partyId: this.centreDetailForm.partyId,
                name: this.centreDetailForm.description,
                gln: this.centreDetailForm.gln,
                town: this.centreDetailForm.town,
                province: this.centreDetailForm.province,
                countryId: this.centreDetailForm.countryId,
                code: this.centreDetailForm.centreCode,
                mailbox: this.centreDetailForm.buzon,
                address: this.centreDetailForm.address,
                cp: this.centreDetailForm.postcode,
                centreType: this.centreDetailForm.centreType
              }

            })

            this.centreDetailForm = response.data
            await this.getCentresOnDatabase()
            // Combo tipo de empresa
            this.loadComboCentreMediaTypeParty()

            this.optionsFilterCentreRoleType = await this.getOptionsFilterCentreRoleType({
              centreId: this.$route.params.centreId,
              buyer: this.isBuyer
            })

            this.$notify({
              title: this.$t('centres.save_changes_notify'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('centreDetailForm: ', this.centreDetailForm)
        }
      })
    },

    async cancelCentreDetailEditForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.cancel')
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        await this.getCentresOnDatabase()
        // Combo tipo de empresa
        this.loadComboCentreMediaTypeParty()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Datos de contacto
    async getCentreMediaOnDatabase () {
      // Get datos de centremedia
      try {
        if (this.$route.params.centreId !== null && this.$route.params.centreId !== undefined) {
          const data = await this.getCentreMedia({ centreId: this.$route.params.centreId })

          this.datacentremedia = data
          for (let index = 0; index < this.datacentremedia.length; index++) {
            if (this.datacentremedia[index].buyer && !this.datacentremedia[index].seller) {
              this.datacentremedia[index].typeText = this.$t('centres.filters.centre_type.buyer')
            } else if (!this.datacentremedia[index].buyer && this.datacentremedia[index].seller) {
              this.datacentremedia[index].typeText = this.$t('centres.filters.centre_type.seller')
            } else if (this.datacentremedia[index].buyer && this.datacentremedia[index].seller) {
              this.datacentremedia[index].typeText = this.$t('centres.filters.centre_type.both')
            }
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Elimina un dato de contacto
    async removeCentreMedia () {
      console.log('removeCentreMedia:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_contact_data')
      })

      try {
        await this.deleteCentreMedia({
          centreId: this.$route.params.centreId,
          centremediaId: this.currentRowCentreMedia.id
        })
        await this.getCentreMediaOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_contact_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Inserta un dato de contacto
    addCentreMedia (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_contact_data')
          })
          try {
            let rol = ''
            if (this.dialogCentreMediaForm.rol === 'buyer') {
              rol = 'BUYER'
            } else if (this.dialogCentreMediaForm.rol === 'seller') {
              rol = 'SELLER'
            } else if (this.dialogCentreMediaForm.rol === 'both') {
              rol = 'BOTH'
            }
            const params = {
              centreId: this.$route.params.centreId,
              projectId: this.$route.params.projectId,
              mediaTypeId: this.dialogCentreMediaForm.mediaTypeId,
              value: this.dialogCentreMediaForm.value,
              centreType: rol
            }

            if (!this.validateEmail(params)) {
              // Si salta validacion ya no hacemos mas comprobaciones
              this.$notify({
                title: this.$t('centres.data_contact_ko'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            } else if (this.validateDataContactRepeat(params)) {
              await this.insertCentreMedia(params)
              await this.getCentreMediaOnDatabase()
              this.$notify({
                title: this.$t('party_detail.notify.add_contact_data'),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            }
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogCentreMedia = false
          }
        } else {
          console.log('addCentreMedia INVALID: ', this.dialogCentreMediaForm)
        }
      })
    },

    // Inserta un rol de centro
    addCentreRole (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('centres.load.add_centre_role')
          })
          try {
            const params = {
              centreId: this.$route.params.centreId,
              projectId: this.$route.params.projectId,
              roleTypeId: this.dialogCentreRoleForm.roleTypeId
            }
            await this.insertCentreRoleTypeCode(params)
            await this.getCentreRoleTypeOnDatabase()
            this.optionsFilterCentreRoleType = await this.getOptionsFilterCentreRoleType({
              centreId: this.$route.params.centreId,
              buyer: this.isBuyer
            })
            this.$notify({
              title: this.$t('centres.notify.add_centre_role'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogCentreRole = false
          }
        } else {
          console.log('addCentreRole INVALID: ', this.dialogCentreRoleForm)
        }
      })
    },

    async getCentreRoleTypeOnDatabase () {
      // Get roles del centro
      try {
        this.centreroles = await this.getCentreRoleTypeCode({ idCentre: this.$route.params.centreId })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async removeCentreRole () {
      // Eliminar rol de centro
      console.log('removeCentreRole:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('centres.load.delete_centre_role')
      })
      try {
        await this.deleteCentreRoleTypeCode({
          centreId: this.$route.params.centreId,
          projectId: this.$route.params.projectId,
          centreRoleTypeCodeId: this.currentRowCentreRole.id
        })
        await this.getCentreRoleTypeOnDatabase()
        this.optionsFilterCentreRoleType = await this.getOptionsFilterCentreRoleType({
          centreId: this.$route.params.centreId,
          buyer: this.isBuyer
        })
        this.$notify({
          title: this.$t('centres.notify.delete_centre_role'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Eliminacion de centro
    handleDeleteCentre () {
      try {
        this.$confirm(this.$t('centres.title_delete_user'), {
          confirmButtonText: this.$t('buttons.btnOk'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          await this.deleteCentreProjectParties(this.$route.params.centreId)
          router.push({ name: 'centro-page' })
          this.$notify({
            title: this.$t('centres.delete_user_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }).catch(() => {})
      } catch (error) {
        console.log('handleDeleteCentre CATCH:: ' + error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('centres.load.text_load_data')
    })
    try {
      if (!this.$route.params.projectId) {
        this.withProject = false
      }
      this.setUserNameCentre()
      this.B2bCreateConfig()

      this.changeBreadcrumbPath(this.$route.params.centreId)
      // Detalle centro
      await this.getCentresOnDatabase()
      // Get datos de contacto-centremedia
      await this.getCentreMediaOnDatabase()
      // Tipo de contacto de un centremedia
      await this.getOptionsFilterMediaType()
      // Get opciones de roles de centro
      this.optionsFilterCentreRoleType = await this.getOptionsFilterCentreRoleType({
        centreId: this.$route.params.centreId,
        buyer: this.isBuyer
      })
      // Get roles del centro
      await this.getCentreRoleTypeOnDatabase()
      // Combo tipo de empresa
      this.loadComboCentreMediaTypeParty()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-centres {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 110px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
      margin-top: 1rem;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
    color: transparent !important;
  }
  ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
    background-color: transparent !important;
    border-color: transparent !important;
  }
}
</style>
